import React, { useState } from 'react';
import Select, { selectClasses } from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Box } from '@mui/joy';
import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';

const transactions = [
    { type: 'Credit', amount: 100, status: 'Completed', time: '2024-01-01T10:30' },
    { type: 'Debit', amount: 50, status: 'Pending', time: '2024-01-02T11:00' },
    { type: 'Credit', amount: 200, status: 'Completed', time: '2024-01-03T12:15' },
    { type: 'Debit', amount: 300, status: 'Failed', time: '2024-01-04T13:45' },
];

export const FundiPaymentSetting = () => {

    const [filters, setFilters] = useState({ type: '', amount: '', time: '', status: '', fromDate: '', toDate: '' });

    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const filteredTransactions = transactions.filter((transaction) => {
        const transactionDate = new Date(transaction.time);
        const fromDate = filters.fromDate ? new Date(filters.fromDate) : null;
        const toDate = filters.toDate ? new Date(filters.toDate) : null;

        return (
            (filters.type ? transaction.type === filters.type : true) &&
            (filters.amount ? transaction.amount.toString().includes(filters.amount) : true) &&
            (filters.time ? transaction.time.includes(filters.time) : true) &&
            (filters.status ? transaction.status === filters.status : true) &&
            (!fromDate || transactionDate >= fromDate) &&
            (!toDate || transactionDate <= toDate)
        );
    });

    return (
        <>

            <Box sx={{ display: 'flex', gap: '20px' }}>
                <Box>
                    <Typography variant="h5">Transaction</Typography>
                    <Select
                        placeholder="All"
                        indicator={<ArrowDropDownIcon sx={{ color: 'green', fontSize: '40px' }} />}
                        sx={{
                            width: 260,
                            height: 50,
                            backgroundColor: 'transparent',
                            border: '1px solid green',
                            '&:hover': {
                                backgroundColor: 'transparent',
                            },
                            [`& .${selectClasses.indicator}`]: {
                                transition: '0.2s',
                                [`&.${selectClasses.expanded}`]: {
                                    transform: 'rotate(-180deg)',
                                },
                            },
                        }}
                    >
                        <Option value="dog">Dog</Option>
                        <Option value="cat">Cat</Option>
                        <Option value="fish">Fish</Option>
                        <Option value="bird">Bird</Option>
                    </Select>
                </Box>

                <Box>
                    <Typography variant="h5">Status</Typography>
                    <Select
                        placeholder="All"
                        indicator={<ArrowDropDownIcon sx={{ color: 'green', fontSize: '40px' }} />}
                        sx={{
                            width: 260,
                            height: 50,
                            backgroundColor: 'transparent',
                            border: '1px solid green',
                            '&:hover': {
                                backgroundColor: 'transparent',
                            },
                            [`& .${selectClasses.indicator}`]: {
                                transition: '0.2s',
                                [`&.${selectClasses.expanded}`]: {
                                    transform: 'rotate(-180deg)',
                                },
                            },
                        }}
                    >
                        <Option value="dog">Dog</Option>
                        <Option value="cat">Cat</Option>
                        <Option value="fish">Fish</Option>
                        <Option value="bird">Bird</Option>
                    </Select>
                </Box>
            </Box>

            <Box sx={{ display: 'flex', gap: '20px' }}>
                <Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                            components={[
                                'DatePicker',
                                'MobileDatePicker',
                                'DesktopDatePicker',
                                'StaticDatePicker',
                            ]}
                        >             
                            <DemoItem label="Period">
                                <DatePicker defaultValue={dayjs('2022-04-17')} />
                            </DemoItem>
                          
                        </DemoContainer>
                    </LocalizationProvider>
                </Box>
                
                <Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                            components={[
                                'DatePicker',
                                'MobileDatePicker',
                                'DesktopDatePicker',
                                'StaticDatePicker',
                            ]}
                        >             
                            <DemoItem label="Period">
                                <DatePicker defaultValue={dayjs('2022-04-17')} />
                            </DemoItem>
                          
                        </DemoContainer>
                    </LocalizationProvider>
                </Box>

            </Box>


        </>
    );
}
